import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class PopoverButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';

  static normalize(styles: Partial<PopoverButtonStyle>): PopoverButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new PopoverButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
